// extracted by mini-css-extract-plugin
module.exports = {"flex":"Main_flex__1kcVM","container":"Main_container__1BVb6"};